<div class="contact-dialog-container">
  <div class="contact-dialog-title">
    @if (!contactDialogData.isAdminView) {
      <h4 mat-dialog-title>{{ contactDialogData?.data ? 'Edit Contact' : 'Invite Contact' }}</h4>
      <mat-icon
        aria-label="Close dialog"
        class="dialog_close"
        role="button"
        svgIcon="k12-circle-xmark"
        (click)="onCancelEditContact()"
        (keydown.enter)="onCancelEditContact()">
      </mat-icon>
    }
  </div>

  <mat-dialog-content>
    <div class="edit-contact-form">
      <form [formGroup]="editContactForm" [class.grid]="!contactDialogData.isAdminView">
        @if (!contactDialogData.isAdminView) {
          <div class="grid-col-12 title">
            <span class="contact_details">Contact Details</span>
          </div>
        }

        <div [class]="!contactDialogData.isAdminView ? 'grid-col-6' : 'contact-form'">
          <label for="hdmaInput">HDMA</label>
          <mat-form-field class="edit-contact-field">
            <input class="edit-contact-input" formControlName="isHDMA" id="hdmaInput" matInput />
          </mat-form-field>
        </div>

        <div [class]="!contactDialogData.isAdminView ? 'grid-col-6' : 'contact-form'">
          <label for="firstNameInput">First Name<span>*</span></label>
          <mat-form-field class="edit-contact-field">
            <input class="edit-contact-input" formControlName="firstName" id="firstNameInput" matInput />
          </mat-form-field>
          <cfi-form-inline-error [control]="editContactForm.get('firstName')" />
        </div>

        <div [class]="!contactDialogData.isAdminView ? 'grid-col-6' : 'contact-form'">
          <label for="lastNameInput">Last Name<span>*</span></label>
          <mat-form-field class="edit-contact-field">
            <input class="edit-contact-input" formControlName="lastName" id="lastNameInput" matInput />
          </mat-form-field>
          <cfi-form-inline-error [control]="editContactForm.get('lastName')" />
        </div>

        <div [class]="!contactDialogData.isAdminView ? 'grid-col-6' : 'contact-form'">
          <label for="jobTitleInput">Job Title/ Position<span>*</span></label>
          <mat-form-field class="edit-contact-field">
            <input class="edit-contact-input" formControlName="jobTitle" id="jobTitleInput" matInput />
          </mat-form-field>
          <cfi-form-inline-error [control]="editContactForm.get('jobTitle')" />
        </div>

        <div [class]="!contactDialogData.isAdminView ? 'grid-col-6' : 'contact-form'">
          <label for="emailInput">Email Address<span>*</span></label>
          <mat-form-field class="edit-contact-field" disabled>
            <input class="edit-contact-input" formControlName="email" id="emailInput" matInput />
          </mat-form-field>
        </div>

        <div [class]="!contactDialogData.isAdminView ? 'grid-col-6' : 'contact-form'">
          <label for="phoneInput">Phone No.</label>
          <mat-form-field class="edit-contact-field">
            <input
              class="edit-contact-input"
              formControlName="phone"
              id="phoneInput"
              matInput
              type="text"
              [dropSpecialCharacters]="false"
              [mask]="'(000) 000-0000'" />
          </mat-form-field>
          <cfi-form-inline-error [control]="editContactForm.get('phone')" />
        </div>

        <div [class]="!contactDialogData.isAdminView ? 'grid-col-6' : 'contact-form contact-form--ext'">
          <label for="extNumberInput">Ext.</label>
          <mat-form-field class="edit-contact-field">
            <input
              class="edit-contact-input"
              formControlName="extNumber"
              id="extNumberInput"
              matInput
              maxlength="4"
              inputmode="numeric"
              (input)="onExtensionInput($event)" />
          </mat-form-field>
        </div>

        <div [class]="!contactDialogData.isAdminView ? 'grid-col-6' : 'contact-form'">
          <label class="title" for="primaryContact">Primary Contact</label>
          @if (contactDialogData.isAdminView) {
            <mat-form-field class="edit-contact-field">
              <mat-select
                id="primaryContactInput"
                class="edit-contact-input"
                data-pw="primary-contact-options"
                formControlName="primaryContact">
                <mat-option [value]="true">Yes</mat-option>
                <mat-option [value]="false">No</mat-option>
              </mat-select>
            </mat-form-field>
          } @else {
            <div class="grid-col-12">
              <mat-radio-group
                aria-labelledby="primary-contact-label"
                id="primaryContact"
                formControlName="primaryContact"
                class="primary-contact-group">
                <mat-radio-button aria-label="Yes" class="primary-contact-option" [value]="true">Yes</mat-radio-button>
                <mat-radio-button aria-label="No" class="primary-contact-option" [value]="false">No</mat-radio-button>
              </mat-radio-group>
            </div>
          }
          @if (!contactDialogData.isAdminView) {
            <ng-container *ngTemplateOutlet="primaryContactHint"></ng-container>
          }
        </div>
      </form>
    </div>

    @if (contactDialogData.isAdminView) {
      <ng-container *ngTemplateOutlet="primaryContactHint"></ng-container>
    }
  </mat-dialog-content>

  <mat-dialog-actions class="contact-dialog-action-buttons">
    @if (contactDialogData.isAdminView) {
      <button
        class="cancel-button secondary_materials_button large_button"
        data-qa="cancel-button"
        disableRipple="true"
        id="cancel-button"
        mat-stroked-button
        tabindex="0"
        (click)="onCancelEditContact()">
        Cancel
      </button>
    }
    <button
      class="primary_materials_button large_button save-button"
      data-qa="save-button"
      disableRipple="true"
      id="save-button"
      mat-stroked-button
      tabindex="0"
      [disabled]="editContactForm.invalid"
      [class.send-contact]="!contactDialogData.isAdminView"
      (click)="onSaveEditContact()">
      {{ !contactDialogData.isAdminView ? (contactDialogData.data ? 'Save Contact' : 'Send Invite') : 'Save' }}
    </button>
  </mat-dialog-actions>
</div>

<ng-template #primaryContactHint>
  @if (contactDialogData?.data && isPrimaryContact) {
    <div class="hint" [style.margin-top]="contactDialogData.isAdminView ? '15px' : '0px'">
      <mat-hint>
        This contact is the school's primary contact. You must change a non-primary contact to a primary contact
      </mat-hint>
    </div>
  }
</ng-template>
